import { render, staticRenderFns } from "./candidateForm.vue?vue&type=template&id=0eda8a60&"
import script from "./candidateForm.vue?vue&type=script&lang=js&"
export * from "./candidateForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports